const getEventId = state => state?.event?.getEventIdData
const getPreviewData = state => state?.ats?.previewData
const selectors = {
  getEventId,
  getPreviewData,
}

export default selectors
